export const ALERTS_DEFAULT_PAGE = ""
export const ALERTS_PAGES = {
  "": "Overview",
  board: "Alerts",
}

export const pages = (
  location: string,
): { section: string; name: string; pages: Record<string, string>; defaultPage: string } => {
  const page = location.split("/").pop()

  let sectionPages: Record<string, string> = {}
  let defaultPage = ""
  sectionPages = ALERTS_PAGES
  defaultPage = ALERTS_DEFAULT_PAGE

  let section = page ?? defaultPage
  let name = sectionPages[section]
  if (!name) {
    section = defaultPage
    name = sectionPages[defaultPage]
  }

  return { section, name, pages: sectionPages, defaultPage }
}
